export default __webpack_public_path__ + "static/906-ce420d25e7d93e9b3ac3c59a89286447.gif";